
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container">
    <a class="navbar-brand" routerLink="home"><span>Renoshop</span>Bee</a>
  
    <button (click)="toggleNavbar()" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" [class.show]="isOpen" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" routerLink="home"  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="women"  routerLinkActive="active">Women</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="men"  routerLinkActive="active">Men</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="kids"  routerLinkActive="active">Kids</a>
        </li>
       
        <li class="nav-item">
          <a class="nav-link" routerLink="jewellery"  routerLinkActive="active">Jewellery</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="accessories"  routerLinkActive="active">Accessories</a>
        </li>
        <li class="nav-item dropdown">
          
          <div (click)="dropdown()"  class= "nav-link dropdown-toggle"  id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">e-commerce</div>
          <div  (click)='drop()' class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" [class.show]="isAdd" >
            <a class="dropdown-item"  routerLink="auth/login" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" >Login</a>
            <a class="dropdown-item" routerLink="auth/signup" routerLinkActive="active">Signup</a>
            <a class="dropdown-item" routerLink="user/cart" routerLinkActive="active">Cart</a>
          </div>
        </li>
        
      </ul>
    </div>
    <div class="content">
      <i class="fas fa-shopping-cart"></i>
    </div>
    </div>
    </nav>
   